import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { useIdleTimer } from "react-idle-timer";
import SessionTimeoutDialog from "../SessionTimeoutDialog";
import { useAuth } from '../../hooks/auth';

const SessionTimeout = ({ save = null, answers, moduleID, statusNumber }) => {
  const [timeoutModalShow, setTimeoutModalShow] = useState(false);
  const [timeoutCountdown, setTimeoutCountdown] = useState(0);
  const timeoutModalVisibleRef = useRef(false);
  const { signOut, user, userRoles } = useAuth();

  const userObject = useMemo(() => {
    if (user == null) return null;
    if (typeof user === "string") {
      try {
        return JSON.parse(user);
      } catch {
        return null;
      }
    }
    return user;
  }, [user]);

  const TIME_UNTIL_LOGOUT = 300;
  const TIME_UNTIL_IDLE = 55;

  const handleLogout = useCallback(async () => {
    timeoutModalVisibleRef.current = false;
    setTimeoutModalShow(false);
    setTimeoutCountdown(0);
    if (user) {
      if (save != null && userObject?.isInternalUser === false) {
        if ((userRoles.includes("RoleAdmin") && statusNumber == 8) //Reactivated By Admin
          || (userRoles.includes("RoleInfoHolder") && (statusNumber == null || statusNumber == 1 || statusNumber == 3 || statusNumber == 5 || statusNumber == 6 || statusNumber == 8)) //Not Saved As Draft OR Save as Draft OR Reopened By Local OR Reopened By Global OR Version Approved OR Reactivated By Admin
          || (userRoles.includes("RoleApprover") && userObject?.companyID == null && statusNumber == 5)) {
          if (userRoles.includes("RoleAdmin") && statusNumber == 8) {
            await save(answers, moduleID, true);
            signOut();
          }
          else {
            await save(answers, moduleID, false);
            signOut();
          }
        }
      }
      else {
        signOut();
      }
    }
  }, [save, answers, moduleID, user, userObject, userRoles, statusNumber, signOut]);

  useEffect(() => {
    if (!timeoutModalShow) return;

    const intervalId = setInterval(() => {
      setTimeoutCountdown((prev) => (prev <= 1 ? 0 : prev - 1));
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeoutModalShow]);

  useEffect(() => {
    if (!timeoutModalShow || timeoutCountdown > 0) return;
    handleLogout();
  }, [timeoutModalShow, timeoutCountdown, handleLogout]);

  useEffect(() => {
    timeoutModalVisibleRef.current = timeoutModalShow;
  }, [timeoutModalShow]);

  const onIdle = () => {
    if (!user || timeoutModalVisibleRef.current) return;
    timeoutModalVisibleRef.current = true;
    setTimeoutModalShow(true);
    setTimeoutCountdown(TIME_UNTIL_LOGOUT);
  };

  useIdleTimer({
    onActive: () => {
      if (!timeoutModalVisibleRef.current) {
        setTimeoutCountdown(0);
      }
    },
    onIdle: onIdle,
    debounce: 250,
    timeout: 1000 * 60 * TIME_UNTIL_IDLE // 55 minutes
  });

  return (
    <>
      <SessionTimeoutDialog
        countdown={timeoutCountdown}
        onContinue={() => {
          timeoutModalVisibleRef.current = false;
          setTimeoutModalShow(false);
          setTimeoutCountdown(0);
        }}
        show={timeoutModalShow}
      />
    </>
  );
}

export default SessionTimeout;
